import { useFormik } from 'formik'
import moment from 'moment-timezone'
import { useIntl } from 'react-intl'
import { getYupSchema, structureSchema } from 'Schemas/yup'

const timezoneConverter = (timeStr) => {
  const timeZone = sessionStorage.getItem('timeZone')
  const utcMoment = moment.utc(timeStr, 'HH:mm')
  if (timeZone) {
    return utcMoment.tz(timeZone)
  } else {
    return utcMoment
  }
}

const useStructureForm = (structure) => {
  const intl = useIntl()
  const formik = useFormik({
    initialValues: {
      id: structure?.id || '',
      status: structure?.status || 'ACTIVE',
      name: structure?.name || '',
      code: structure?.code || '',
      email: structure?.email || '',
      phoneCountryCode: structure?.phoneCountryCode?.trim() || '',
      phone: structure?.phone?.trim() || '',
      checkIn: {
        from: structure?.defaultCheckInFromTime ? timezoneConverter(structure?.defaultCheckInFromTime) : null,
        to: structure?.defaultCheckInToTime ? timezoneConverter(structure.defaultCheckInToTime) : null
      },
      checkOut: {
        from: structure?.defaultCheckOutFromTime ? timezoneConverter(structure.defaultCheckOutFromTime) : null,
        to: structure?.defaultCheckOutToTime ? timezoneConverter(structure.defaultCheckOutToTime) : null
      }
      // checkOut: moment().startOf('day')
    },
    enableReinitialize: true,
    validationSchema: getYupSchema(structureSchema, intl, [
      'name',
      'email',
      'phone',
      'phoneCountryCode',
      'checkIn',
      'checkOut'
    ])
  })
  return formik
}

export default useStructureForm
